// extracted by mini-css-extract-plugin
export default {"container":"container__SidebarNavigation__7EHWS","tab":"tab__SidebarNavigation__7EHWS","activeTab":"activeTab__SidebarNavigation__7EHWS"};